{
  "appName": "عملاء مسافر",
  "actions": {
    "add": "إضافة",
    "create": "إنشاء",
    "edit": "تعديل",
    "view": "عرض",
    "viewDetails": "عرض التفاصيل",
    "delete": "حذف",
    "save": "حفظ",
    "saveChanges": "حفظ التغييرات",
    "saving": "جاري الحفظ...",
    "cancel": "إلغاء",
    "confirm": "تأكيد",
    "close": "إغلاق",
    "back": "رجوع",
    "search": "بحث",
    "searchPlaceholder": "بحث...",
    "filters": "الفلاتر",
    "applyFilters": "تطبيق الفلاتر",
    "resetFilters": "إعادة تعيين الفلاتر",
    "exportToExcel": "تصدير إلى Excel",
    "exporting": "تصدير...",
    "print": "طباعة",
    "refresh": "تحديث",
    "retry": "إعادة المحاولة",
    "activate": "تفعيل",
    "deactivate": "تعطيل",
    "changeStatus": "تغيير الحالة",
    "restore": "استعادة",
    "copy": "نسخ",
    "copied": "تم النسخ"
  },
  "fields": {
    "actions": "إجراءات",
    "status": "الحالة",
    "fromDate": "من تاريخ",
    "toDate": "إلى تاريخ",
    "name": "الاسم",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "address": "العنوان",
    "code": "الرمز",
    "branch": "الفرع",
    "branches": "الفروع",
    "createdAt": "تم الإنشاء في",
    "createdBy": "تم الإنشاء بواسطة",
    "updatedAt": "تم التحديث في",
    "updatedBy": "تم التحديث بواسطة"
  },
  "status": {
    "active": "نشط",
    "inactive": "غير نشط",
    "deleted": "محذوف",
    "pending": "قيد الانتظار",
    "reversed": "معكوسة"
  },
  "systems": {
    "CURRENCY": "العملات",
    "POS": "نقاط البيع",
    "FUEL": "المحروقات",
    "DEPOSITS": "الأمانات النقدية",
    "TRANSFERS": "الحوالات",
    "DEBTS": "الذمم"
  },
  "yesNo": {
    "yes": "نعم",
    "no": "لا"
  },
  "state": {
    "loading": "جاري التحميل",
    "noResults": "لا توجد نتائج.",
    "noData": "لا توجد بيانات متاحة",
    "tryAdjustingFilters": "جرب تعديل المرشحات لرؤية المزيد من النتائج",
    "error": "تعذر تحميل البيانات. أعد المحاولة."
  },
  "table": {
    "rowsPerPage": "الصفوف في الصفحة",
    "showing": "عرض {{start}}-{{end}} من {{total}}"
  },
  "pagination": {
    "previous": "السابق",
    "next": "التالي",
    "label": "التنقل بين الصفحات",
    "goToPrevious": "الذهاب إلى الصفحة السابقة",
    "goToNext": "الذهاب إلى الصفحة التالية",
    "morePages": "صفحات أخرى"
  },
  "form": {
    "requiredFieldsNote": "الحقول المطلوبة مميزة بعلامة النجمة",
    "required": "هذا الحقل مطلوب",
    "maxLength": "لا يمكن أن يتجاوز {{max}} حرفا",
    "minLength": "يجب أن يكون على الأقل {{min}} حرفا",
    "invalidFormat": "تنسيق غير صالح",
    "discardChanges": "تجاهل التغييرات؟",
    "discardChangesDescription": "ستفقد التغييرات غير المحفوظة.",
    "discard": "تجاهل",
    "keepEditing": "متابعة التعديل"
  },
  "dialog": {
    "deleteConfirmation": "تأكيد الحذف",
    "areYouSure": "هل أنت متأكد تماما؟"
  },
  "accessDenied": {
    "title": "تم رفض الوصول",
    "description": "ليس لديك صلاحية لعرض هذه الصفحة"
  },
  "language": {
    "label": "اللغة",
    "ar": "العربية",
    "en": "الإنجليزية",
    "switchTo": {
      "ar": "التبديل إلى العربية",
      "en": "التبديل إلى الإنجليزية"
    },
    "short": {
      "ar": "عربي",
      "en": "EN"
    }
  },
  "theme": {
    "switchToLight": "التبديل إلى الوضع الفاتح",
    "switchToDark": "التبديل إلى الوضع الداكن"
  },
  "notFound": {
    "title": "الصفحة غير موجودة",
    "description": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
    "action": "العودة إلى العملاء"
  },
  "combobox": {
    "placeholder": "اختر...",
    "search": "بحث...",
    "empty": "لا توجد نتائج",
    "clearOption": "بدون",
    "clearSelection": "مسح التحديد",
    "removeSelection": "إزالة {{label}}",
    "selectedCount_one": "تم اختيار {{count}} عنصر",
    "selectedCount_two": "تم اختيار {{count}} عنصر",
    "selectedCount_few": "تم اختيار {{count}} عناصر",
    "selectedCount_many": "تم اختيار {{count}} عنصر",
    "selectedCount_other": "تم اختيار {{count}} عنصر"
  },
  "filterToolbar": {
    "phoneCountryCode": "رمز الدولة",
    "toggle": "الفلاتر",
    "resetFilters": "إعادة تعيين الفلاتر"
  },
  "sidebar": {
    "toggle": "تبديل الشريط الجانبي",
    "title": "القائمة الجانبية",
    "description": "التنقل بين صفحات النظام"
  },
  "breadcrumb": {
    "label": "مسار التنقل",
    "more": "المزيد"
  },
  "selection": {
    "selectRow": "تحديد الصف"
  },
  "toaster": {
    "label": "الإشعارات"
  }
}
